import { staticApi } from "src/services/api";
import { isLangAbsent, redirectWithLang } from "./utils/loader-utils";
import { STATIC_ELEMENT } from "src/constants/static";

export async function loader({ request }) {
  if (isLangAbsent(request)) return redirectWithLang(request);

  const lang = new URL(request.url).searchParams.get("lang");
  const footer = await staticApi
    .getStaticFiles(window.SERVER_DATA.REACT_APP_TENANT_NAME, lang, STATIC_ELEMENT.footer)
    .then((res) => ({ data: res }));

  return { footer };
}
